module.exports = __webpack_public_path__ + "img/12hotpot.982a3c0e.svg";